import React, { useContext, useEffect } from 'react';
import { Switch, Redirect, Route } from 'react-router-dom';
import { Box } from '@material-ui/core';

import { SingleVideoPage } from '../../pages/SingleVideoPage';
import { RXDLandingPage } from '../../pages/RXDLangingPage';
import { RXDTestPage } from '../../pages/RXDTestPage';
import { Header } from '../../components/Header';
import { Tenant, LearnerInfo } from '../../types';
import useStyles from './styles';
import { RXDContext } from '../../context/RXDContext';
import { ScriptsContext } from '../../context/ScriptsContext';
import ProtectedRXDRoute from '../../components/ProtectedRXDRoute/ProtectedRXDRoute';
import { Loader } from '../../components/Loader';

interface RXDLayoutProps {
  tenant: Tenant;
  userInfo: LearnerInfo;
  userLoading: boolean;
}

const RXDLayout: React.FC<RXDLayoutProps> = ({ tenant, userInfo, userLoading }) => {
  const logoUrl = tenant?.logo_url;
  const classes = useStyles();

  const { rxdUserInfo } = useContext(RXDContext);
  const { isLoadedAnalyticScript } = useContext(ScriptsContext);

  useEffect(() => {
    if (isLoadedAnalyticScript && (rxdUserInfo || userInfo) && window?.verseEvents?.changeUserId) {
      window.verseEvents.changeUserId(rxdUserInfo ? rxdUserInfo?.id : userInfo?.id);
    }
  }, [userInfo, rxdUserInfo, isLoadedAnalyticScript]);

  return (
    <>
      <Header onlyLogo={true} logoUrl={logoUrl} />
      <Box className={classes.root}>
        <Switch>
          <ProtectedRXDRoute
            exact
            path="/rxd/videos/:slug/"
            userInfo={userInfo}
            userLoading={userLoading}
            render={(props) => (
              <SingleVideoPage {...props} isXApiPage={true} userInfo={null} fallback={<Loader />} />
            )}
          />
          <Route
            exact
            path="/rxd/landing"
            render={(props) => <RXDLandingPage fallback={<Loader />} {...props} />}
          />
          <Route
            exact
            path="/rxd/test"
            render={(props) => <RXDTestPage fallback={<Loader />} {...props} />}
          />
          <Redirect to="/" />
        </Switch>
      </Box>
    </>
  );
};

export default RXDLayout;
